import { Box, Typography } from '../..';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    style?: React.CSSProperties;
    boxStyle?: React.CSSProperties;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, style, boxStyle, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
            style={style}
        >
            {value === index && (
                <Box sx={boxStyle}>
                    <Typography component="div">{children}</Typography>
                </Box>
            )}
        </div>
    );
}

export default TabPanel;
